import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import {AlertProvider} from "./context/AlertContext";
import { MenuPrefsProvider } from "./context/MenuPrefsContext";
import { AccessRightsProvider } from "./context/AccessRightsContext";
import AppRoutes from "./rotes/AppRoutes";
import "./App.css";

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <AccessRightsProvider>
                    <MenuPrefsProvider>
                        <AlertProvider>
                            <AppRoutes />
                        </AlertProvider>
                    </MenuPrefsProvider>
                </AccessRightsProvider>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;